module.exports = __webpack_public_path__ + "img/sec2.2.d0e6df54.png";